export default __webpack_public_path__ + "static/media/GithubIcon.88f9d0d1.svg";